package signSymptom.containers


import com.jingfangpai.api.clients.SignSymptomApiClient
import react.*
import react.dom.div
import setTitle
import signSymptom.components.SignSymptomList

external interface SignSymptomListPageProps : RProps {

}

data class SignSymptomListPageContextData(var getSignSymptomList: (okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.SignSymptom>>) -> Unit,errorCallback:(Throwable)->Unit)->Unit)

val SignSymptomListPageContext = createContext(SignSymptomListPageContextData({ okCallback, errorCallback -> }))

val SignSymptomListPageProvider = functionalComponent<SignSymptomListPageProps> { props ->

    setTitle("体征症状")

    useEffectOnce {
        console.log("doing something with param")
    }

    SignSymptomListPageContext.Provider(SignSymptomListPageContextData(SignSymptomApiClient::getList)) {
        div("SignSymptomListPage-page") {
           child(SignSymptomList)
        }
    }
}
